import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Slider Module
 * utilizes TinySlider package
 * to get things sliding
 */
export default class {
  /**
   * create TinySlider instance and wire navigation styling callbacks up
   */
  constructor() {
    if (document.querySelector('[data-slider-id="jokes"]')) {
      this.currentSlideElement = document.querySelector('[data-jokes-slide-number]');
      this.sliderJokes = tns({
        container: '[data-jokes-slider]',
        mode: 'gallery',
        items: 1,
        slideBy: 'page',
        controls: true,
        controlsPosition: 'bottom',
        arrowKeys: true,
        nav: true,
        navPosition: 'bottom',
        prevButton: '[data-jokes-prev]',
        nextButton: '[data-jokes-next]',
        loop: true,
        mouseDrag: true,
        preventScrollOnTouch: 'auto',
        onInit: (info) => this.updateSlideNumber(info),
      });
      this.sliderJokes.events.on('indexChanged', (info) => this.updateSlideNumber(info));
    }
  }

  /**
   * @function updateSlideNumber
   * @param {Object} info - getInfo() of tiny-slider .
   */
  updateSlideNumber({ displayIndex, pages }) {
    if (!this) {
      return;
    }
    this.currentSlideElement.textContent = `${displayIndex} / ${pages}`;
  }
}
